export default "__VITE_ASSET__C6PUZkr8__"